<script lang="ts">
    import { getContext } from 'svelte'
    import { derived as sderived, writable } from 'svelte/store'
    import type { Writable } from 'svelte/store'

    import Icon from '@iconify/svelte'
    import { DateTime } from 'luxon'

    import type { CrumbArray } from 'hydria/components/breadcrumb'
    import { iconExclamationTriangle } from 'hydria/icons'
    import { gettext as _, tgettext } from 'hydria/services/gettext'
    import { spath } from 'hydria/svelte_helpers'

    import { Breadcrumb } from 'breadcrumb'

    import type { GenOrder } from './order'

    import OrderBlockActivation from './Blocks/Activation.svelte'
    import OrderBlockAddress from './Blocks/Address.svelte'
    import OrderBlockAddStuff from './Blocks/AddStuff.svelte'
    import OrderBlockEmail from './Blocks/Email.svelte'
    import OrderBlockItems from './Blocks/Items.svelte'
    import OrderBlockPayment from './Blocks/Payment.svelte'
    import OrderBlockReopen from './Blocks/Reopen.svelte'
    import OrderStatusBlock from './Blocks/Status.svelte'
    import OrderBlockTransactions from './Blocks/Transactions.svelte'

    const Order = getContext('Order') as GenOrder

    const status = sderived(Order.status, ($status) => $status)
    const fullyCompleted = sderived(Order.fullyCompleted, ($fullyCompleted) => $fullyCompleted)

    const selectedItems: Writable<Set<string>> = writable(new Set())
    // setContext('selectedCartItems', selectedItems)

    let order = sderived(Order.orderStore, ($order) => $order)

    // const unsubs: any[] = []
    // onDestroy(() => {
    //     for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    // })

    const crumbs = sderived([status, order], ([$status, $order]) => {
        const crs: CrumbArray = [{ txt: tgettext('Orders'), url: spath('/ecom/orders') }]

        if ($status == 'ready' || $status == 'loading') {
            if ($status == 'ready' && $order)
                crs.push({
                    txt: $order.ctime.toLocaleString(DateTime.DATETIME_MED),
                })
            else if ($status == 'ready' || $status == 'loading')
                crs.push({
                    txt: '<div class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />',
                    html: true,
                })
            crs.push({
                txt: `<span class="text-muted">${Order.orderId}</span>`,
                html: true,
            })
        } else {
            crs.push({
                txt: iconExclamationTriangle,
                html: true,
            })
        }

        return crs
    })
</script>

<Breadcrumb {crumbs} />

<div class="d-grid gap-4">
    {#if $status == 'not-found' || $status == 'error'}
        <div class="alert alert-danger">
            <Icon inline icon="fa:exclamation-triangle" />
            {#if $status == 'not-found'}
                {$_('The requested document does not exist.')}
            {:else}
                {$_('An error occured. Please try again in a moment.')}
            {/if}
        </div>
    {:else if $status == 'loading'}
        <div class="card">
            <div class="card-body">
                <div class="m-4 d-flex justify-content-center align-items-center">
                    <div class="spinner-border me-3" role="status" aria-hidden="true"></div>
                </div>
            </div>
        </div>
    {:else}
        <OrderStatusBlock />

        <OrderBlockItems {selectedItems} />

        <div class="row">
            <div class="col-sm-8 d-grid gap-4">
                {#if $status == 'ready' && ['unpaid', 'paid'].includes($order.status) && !$order.finalized}
                    <OrderBlockActivation {selectedItems} />
                {/if}
                {#if $order && !['final', 'paid', 'deleted'].includes($order.status)}
                    <OrderBlockAddStuff />
                {/if}
                {#if $status == 'ready' && ['draft', 'ready', 'unpaid', 'quotation'].includes($order.status) && $fullyCompleted}
                    <OrderBlockPayment />
                {/if}
                {#if $status == 'ready' && $order.status == 'final'}
                    <OrderBlockReopen />
                {/if}
            </div>
            <div class="col-sm-4 d-grid gap-4">
                <OrderBlockAddress />

                <!-- Important: Marche pour les autres statuts aussi, mais le texte du message invite à payer. Donc il faudrait créer d'autres messages pour une facture déjà payée. -->
                {#if $order && $fullyCompleted && ['unpaid', 'draft', 'ready'].includes($order.status)}
                    <OrderBlockEmail />
                {/if}
            </div>
        </div>

        <OrderBlockTransactions />
    {/if}
</div>
